import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { openDialog } from '../../../base/dialog/actions';
import { translate } from '../../../base/i18n/functions';
import { IconSubtitles } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { isCaptionTranscriptRetentionAllowed } from '../../captionPreferences';
import CaptionTranscriptDialog from './CaptionTranscriptDialog';
/**
 * Opens the local in-room caption transcript.
 */
class CaptionTranscriptButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'captionTranscript.open';
        this.icon = IconSubtitles;
        this.label = 'captionTranscript.menuLabel';
        this.tooltip = 'captionTranscript.title';
    }
    /**
     * Handles clicking / pressing the button.
     *
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        sendAnalytics(createToolbarEvent('caption.transcript.open'));
        dispatch(openDialog(CaptionTranscriptDialog));
    }
    _isDisabled() {
        return !isCaptionTranscriptRetentionAllowed();
    }
}
export default translate(connect()(CaptionTranscriptButton));
